module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/august-host-exclusives-look/"},"excerpt":"In a world where you can be anything, be kind! Kindness is free! Let’s sprinkle it everywhere like confetti! Check out this beautiful sneak…","timeToRead":1,"frontmatter":{"title":"Kindness Matters","category":"hostess exclusives"}}}]},"site":{"siteMetadata":{"facebook":{"appId":"885294908345276"}}}},"pathContext":{"category":"hostess exclusives"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/category-hostess-exclusives.json
// module id = 743
// module chunks = 211306052543826